import { css } from '@emotion/react';
import { colors, typography } from '#themes/stena-recycling';

export const styles = {
  Description: css`
    ${typography.body.medium};
    color: ${colors.primary.grey};
  `,
};
